<ng-template #syncTemplate let-columninput="column" let-elementinput="element" let-valueinput="value">
  <div class="ms-2">
    <app-syncr-in-grid [syncrvalue]="valueinput"></app-syncr-in-grid>
  </div>
</ng-template>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [specificColumnsTemplates]="[
                        {key: 'sync', template: syncTemplate}
               ]"
               [listEditPathCallback]="getListEditPathCallback()">
</app-crud-list>
